import React from 'react';
import {Flex, Text, Center, Box} from '@chakra-ui/react';
import Image from 'next/image';
import {ResponsiveImageType} from 'react-datocms';
import {DatoCmsImage} from '../datocms/image';

interface AuthenicityCardProps {
  color: string;
  background?: string;
  cardText: string;
  authenticatorText: string;
  srcText?: string;
  boxStyle?: 'rounded' | 'short';
  companyLogo?: ResponsiveImageType;
}
const AuthenticityCard: React.FC<AuthenicityCardProps> = ({
  color,
  background,
  cardText,
  authenticatorText,
  srcText,
  boxStyle = 'rounded',
  companyLogo,
}) => {
  const imgWidth = '208px';
  const imgHeight = '62px';
  return (
    <Center
      pt={
        boxStyle === 'short'
          ? {base: '56px', md: '56px', lg: '20px'}
          : {base: '45px', md: '56px'}
      }
      pb={
        boxStyle === 'short'
          ? {base: '38px', md: '38px'}
          : {base: '64px', md: '70px'}
      }
      flexDir={{base: 'column', md: 'row'}}
      flex={1}
      layerStyle="card"
      background={background || 'black'}
      borderTopRadius="0"
      borderBottomRadius={boxStyle === 'short' ? 0 : {base: '12px', md: '24px'}}
    >
      <Flex flexDir={{base: 'column', md: 'row'}} alignItems="center">
        {companyLogo && (
          <Box maxW="220px">
            <DatoCmsImage responsiveImage={companyLogo} preloadImage />
          </Box>
        )}
        {srcText && (
          <Image
            width={imgWidth}
            height={imgHeight}
            src={srcText}
            alt={authenticatorText}
          />
        )}
        <Text
          textStyle="h6"
          color={color}
          textAlign="center"
          pt={{base: 8, md: 0}}
          ml={{base: 0, md: '60px'}}
          maxW={{base: '260px', md: 'none'}}
        >
          {cardText}{' '}
          <Text as="span" color="white">
            {authenticatorText}
          </Text>
        </Text>
      </Flex>
    </Center>
  );
};

export {AuthenticityCard};
